// Provider-portal translations. Every language supplies the same keys; missing
// keys fall back to English at lookup time (see ProviderLanguageContext).
export const PROVIDER_LANGUAGES = [
    { code: "eng", name: "English" },
    { code: "hin", name: "Hindi", native: "हिन्दी" },
    { code: "tam", name: "Tamil", native: "தமிழ்" },
    { code: "tel", name: "Telugu", native: "తెలుగు" },
    { code: "kan", name: "Kannada", native: "ಕನ್ನಡ" },
];

const translations = {
    eng: {
        back: "Back", cancel: "Cancel", save: "Save", edit: "Edit", close: "Close",
        search: "Search", notProvided: "Not provided", notSpecified: "Not specified",
        na: "N/A", active: "Active", inactive: "Inactive", status: "Status",
        actions: "Actions", name: "Name", gender: "Gender", male: "Male",
        female: "Female", others: "Others", email: "Email", phone: "Phone",
        age: "Age", notSet: "\u2014 Not set \u2014",

        myProfile: "My Profile", resetPassword: "Reset Password",
        editProfile: "Edit Profile", memberSince: "Member since",
        mobileNumber: "Mobile Number", preferredLanguage: "Preferred Language",
        fullName: "Full Name", emailAddress: "Email Address", phoneNumber: "Phone Number",

        registeredDoctors: "Registered Doctors", doctor: "Doctor",
        specialization: "Specialization", patients: "Patients", addDoctor: "Add Doctor",
        deleteDoctors: "Delete Doctors", noDoctorsFound: "No doctors found",
        editDoctor: "Edit Doctor", createDoctor: "Create Doctor",
        updateDoctor: "Update Doctor", doctorName: "Doctor Name", speciality: "Speciality",

        todayAppointment: "Today Appointment", personalInfo: "Personal Info",
        assignedDoctor: "Assigned Doctor",

        subscriberDetails: "Subscriber Details", treatmentHistory: "Treatment History",
        preSessionDetails: "Pre-Session Details", postSessionDetails: "Post-Session Details",
        commonSymptoms: "Common Symptoms", assessmentScore: "Assessment Score",
        postVital: "Post Vital", feedback: "Feedback", medicalInformation: "Medical Information",
        primaryDiagnosis: "Primary Diagnosis", dateOfDiagnosis: "Date of Diagnosis",
        treatmentStartDate: "Treatment Start Date", hospital: "Hospital",
        hospitalClinic: "Hospital / Clinic", diagnosis: "Diagnosis", createdAt: "Created At",
        latestHadsScore: "Latest HADS Score",
        assessmentsAdministered: "Number of Assessments Administered",
        treatmentCycle: "Treatment Cycle", complete: "Complete", incomplete: "Incomplete",
        notCompletedForSession: "Not completed for this session",
        noAssessmentsAssigned: "No assessments were assigned for this session",
        noFeedback: "No feedback submitted for this session",
        postVitalUnavailable: "Post vital data not available",

        bloodPressure: "Blood Pressure", heartRate: "Heart Rate", painScale: "Pain Scale",
        moodRating: "Mood Rating", sleepQuality: "Sleep Quality", nausea: "Nausea",
        fatigue: "Fatigue", anxiety: "Anxiety", depression: "Depression",
        appetiteLoss: "Appetite Loss", assessmentType: "Assessment Type",

        treatmentSession: "Treatment Session", sessionDetails: "Session Details",
        systolic: "Systolic", diastolic: "Diastolic", noPain: "No Pain", worstPain: "Worst Pain",

        registeredPatients: "Registered Patients", addPatient: "Add Patient",
        deletePatients: "Delete Patients", todaysPatient: "Today's Patient",
        doctors: "Doctors", progressTracking: "Progress Tracking",
        currentCycle: "Current Cycle", sessionCompleted: "Session Completed",
        analytics: "Analytics", startSession: "Start Session", underAge: "Under Age",
        notConsented: "Not Consented", notQualified: "Not Qualified",
        preHadsScreening: "Pre-HADS Screening", createPatient: "Create Patient",
        editPatient: "Edit Patient", updatePatient: "Update Patient",
        personalInformation: "Personal Information", firstName: "First Name",
        lastName: "Last Name", dateOfBirth: "Date of Birth", month: "Month",
        day: "Day", year: "Year", packageType: "Package Type", basic: "Basic",
        premium: "Premium", premiumPlus: "Premium Plus", knowYourPlan: "Know your plan",
        caregiver: "Caregiver", caregiverMobileNumber: "Caregiver Mobile Number",
        caregiverName: "Caregiver Name", caregiverEmail: "Caregiver Email",
        category: "Category", risk: "Risk", nonRisk: "Non-Risk",
    },

    hin: {
        back: "वापस", cancel: "रद्द करें", save: "सहेजें", edit: "संपादित करें", close: "बंद करें",
        search: "खोजें", notProvided: "उपलब्ध नहीं", notSpecified: "निर्दिष्ट नहीं",
        na: "लागू नहीं", active: "सक्रिय", inactive: "निष्क्रिय", status: "स्थिति",
        actions: "कार्रवाई", name: "नाम", gender: "लिंग", male: "पुरुष",
        female: "महिला", others: "अन्य", email: "ईमेल", phone: "फ़ोन",
        age: "आयु", notSet: "\u2014 निर्धारित नहीं \u2014",

        myProfile: "मेरी प्रोफ़ाइल", resetPassword: "पासवर्ड रीसेट करें",
        editProfile: "प्रोफ़ाइल संपादित करें", memberSince: "सदस्य बने",
        mobileNumber: "मोबाइल नंबर", preferredLanguage: "पसंदीदा भाषा",
        fullName: "पूरा नाम", emailAddress: "ईमेल पता", phoneNumber: "फ़ोन नंबर",

        registeredDoctors: "पंजीकृत डॉक्टर", doctor: "डॉक्टर",
        specialization: "विशेषज्ञता", patients: "मरीज़", addDoctor: "डॉक्टर जोड़ें",
        deleteDoctors: "डॉक्टर हटाएं", noDoctorsFound: "कोई डॉक्टर नहीं मिला",
        editDoctor: "डॉक्टर संपादित करें", createDoctor: "डॉक्टर बनाएं",
        updateDoctor: "डॉक्टर अपडेट करें", doctorName: "डॉक्टर का नाम", speciality: "विशेषज्ञता",

        todayAppointment: "आज की अपॉइंटमेंट", personalInfo: "व्यक्तिगत जानकारी",
        assignedDoctor: "नियुक्त डॉक्टर",

        subscriberDetails: "सदस्य विवरण", treatmentHistory: "उपचार इतिहास",
        preSessionDetails: "सत्र-पूर्व विवरण", postSessionDetails: "सत्र-पश्चात विवरण",
        commonSymptoms: "सामान्य लक्षण", assessmentScore: "मूल्यांकन स्कोर",
        postVital: "सत्र-पश्चात वाइटल", feedback: "प्रतिक्रिया", medicalInformation: "चिकित्सा जानकारी",
        primaryDiagnosis: "प्राथमिक निदान", dateOfDiagnosis: "निदान की तिथि",
        treatmentStartDate: "उपचार प्रारंभ तिथि", hospital: "अस्पताल",
        hospitalClinic: "अस्पताल / क्लिनिक", diagnosis: "निदान", createdAt: "बनाया गया",
        latestHadsScore: "नवीनतम HADS स्कोर",
        assessmentsAdministered: "किए गए मूल्यांकन की संख्या",
        treatmentCycle: "उपचार चक्र", complete: "पूर्ण", incomplete: "अपूर्ण",
        notCompletedForSession: "इस सत्र के लिए पूर्ण नहीं",
        noAssessmentsAssigned: "इस सत्र के लिए कोई मूल्यांकन नहीं सौंपा गया",
        noFeedback: "इस सत्र के लिए कोई प्रतिक्रिया नहीं दी गई",
        postVitalUnavailable: "सत्र-पश्चात वाइटल उपलब्ध नहीं",

        bloodPressure: "रक्तचाप", heartRate: "हृदय गति", painScale: "दर्द स्केल",
        moodRating: "मनोदशा रेटिंग", sleepQuality: "नींद की गुणवत्ता", nausea: "मतली",
        fatigue: "थकान", anxiety: "चिंता", depression: "अवसाद",
        appetiteLoss: "भूख में कमी", assessmentType: "मूल्यांकन प्रकार",

        treatmentSession: "उपचार सत्र", sessionDetails: "सत्र विवरण",
        systolic: "सिस्टोलिक", diastolic: "डायस्टोलिक", noPain: "कोई दर्द नहीं", worstPain: "अत्यधिक दर्द",

        registeredPatients: "पंजीकृत मरीज़", addPatient: "मरीज़ जोड़ें",
        deletePatients: "मरीज़ हटाएं", todaysPatient: "आज के मरीज़",
        doctors: "डॉक्टर", progressTracking: "प्रगति ट्रैकिंग",
        currentCycle: "वर्तमान चक्र", sessionCompleted: "पूर्ण सत्र",
        analytics: "विश्लेषण", startSession: "सत्र प्रारंभ करें", underAge: "आयु कम",
        notConsented: "सहमति नहीं", notQualified: "योग्य नहीं",
        preHadsScreening: "HADS पूर्व-जांच", createPatient: "मरीज़ जोड़ें",
        editPatient: "मरीज़ संपादित करें", updatePatient: "मरीज़ अपडेट करें",
        personalInformation: "व्यक्तिगत जानकारी", firstName: "पहला नाम",
        lastName: "अंतिम नाम", dateOfBirth: "जन्म तिथि", month: "माह",
        day: "दिन", year: "वर्ष", packageType: "पैकेज प्रकार", basic: "बेसिक",
        premium: "प्रीमियम", premiumPlus: "प्रीमियम प्लस", knowYourPlan: "अपनी योजना जानें",
        caregiver: "देखभालकर्ता", caregiverMobileNumber: "देखभालकर्ता मोबाइल नंबर",
        caregiverName: "देखभालकर्ता का नाम", caregiverEmail: "देखभालकर्ता ईमेल",
        category: "श्रेणी", risk: "जोखिम", nonRisk: "गैर-जोखिम",
    },

    tam: {
        back: "பின்செல்", cancel: "ரத்து செய்", save: "சேமி", edit: "திருத்து", close: "மூடு",
        search: "தேடு", notProvided: "வழங்கப்படவில்லை", notSpecified: "குறிப்பிடப்படவில்லை",
        na: "பொருந்தாது", active: "செயலில்", inactive: "செயலற்ற", status: "நிலை",
        actions: "செயல்கள்", name: "பெயர்", gender: "பாலினம்", male: "ஆண்",
        female: "பெண்", others: "மற்றவை", email: "மின்னஞ்சல்", phone: "தொலைபேசி",
        age: "வயது", notSet: "\u2014 அமைக்கப்படவில்லை \u2014",

        myProfile: "என் சுயவிவரம்", resetPassword: "கடவுச்சொல்லை மீட்டமை",
        editProfile: "சுயவிவரத்தைத் திருத்து", memberSince: "உறுப்பினர் ஆனது",
        mobileNumber: "கைபேசி எண்", preferredLanguage: "விருப்ப மொழி",
        fullName: "முழு பெயர்", emailAddress: "மின்னஞ்சல் முகவரி", phoneNumber: "தொலைபேசி எண்",

        registeredDoctors: "பதிவு செய்யப்பட்ட மருத்துவர்கள்", doctor: "மருத்துவர்",
        specialization: "சிறப்புத்துறை", patients: "நோயாளிகள்", addDoctor: "மருத்துவரைச் சேர்",
        deleteDoctors: "மருத்துவர்களை நீக்கு", noDoctorsFound: "மருத்துவர்கள் இல்லை",
        editDoctor: "மருத்துவரைத் திருத்து", createDoctor: "மருத்துவரை உருவாக்கு",
        updateDoctor: "மருத்துவரைப் புதுப்பி", doctorName: "மருத்துவர் பெயர்", speciality: "சிறப்புத்துறை",

        todayAppointment: "இன்றைய சந்திப்பு", personalInfo: "தனிப்பட்ட தகவல்",
        assignedDoctor: "நியமிக்கப்பட்ட மருத்துவர்",

        subscriberDetails: "சந்தாதாரர் விவரங்கள்", treatmentHistory: "சிகிச்சை வரலாறு",
        preSessionDetails: "அமர்வுக்கு முந்தைய விவரங்கள்", postSessionDetails: "அமர்வுக்குப் பிந்தைய விவரங்கள்",
        commonSymptoms: "பொதுவான அறிகுறிகள்", assessmentScore: "மதிப்பீட்டு மதிப்பெண்",
        postVital: "அமர்வுக்குப் பின் உயிர்நிலை", feedback: "கருத்து", medicalInformation: "மருத்துவ தகவல்",
        primaryDiagnosis: "முதன்மை நோயறிதல்", dateOfDiagnosis: "நோயறிதல் தேதி",
        treatmentStartDate: "சிகிச்சை தொடக்க தேதி", hospital: "மருத்துவமனை",
        hospitalClinic: "மருத்துவமனை / கிளினிக்", diagnosis: "நோயறிதல்", createdAt: "உருவாக்கப்பட்டது",
        latestHadsScore: "சமீபத்திய HADS மதிப்பெண்",
        assessmentsAdministered: "மேற்கொள்ளப்பட்ட மதிப்பீடுகளின் எண்ணிக்கை",
        treatmentCycle: "சிகிச்சை சுழற்சி", complete: "முடிந்தது", incomplete: "முடியவில்லை",
        notCompletedForSession: "இந்த அமர்வுக்கு முடிக்கப்படவில்லை",
        noAssessmentsAssigned: "இந்த அமர்வுக்கு மதிப்பீடுகள் எதுவும் ஒதுக்கப்படவில்லை",
        noFeedback: "இந்த அமர்வுக்கு கருத்து அளிக்கப்படவில்லை",
        postVitalUnavailable: "அமர்வுக்குப் பிந்தைய உயிர்நிலை தரவு இல்லை",

        bloodPressure: "இரத்த அழுத்தம்", heartRate: "இதய துடிப்பு", painScale: "வலி அளவுகோல்",
        moodRating: "மனநிலை மதிப்பீடு", sleepQuality: "தூக்கத் தரம்", nausea: "குமட்டல்",
        fatigue: "சோர்வு", anxiety: "கவலை", depression: "மனச்சோர்வு",
        appetiteLoss: "பசியின்மை", assessmentType: "மதிப்பீட்டு வகை",

        treatmentSession: "சிகிச்சை அமர்வு", sessionDetails: "அமர்வு விவரங்கள்",
        systolic: "சிஸ்டாலிக்", diastolic: "டயஸ்டாலிக்", noPain: "வலி இல்லை", worstPain: "கடுமையான வலி",

        registeredPatients: "பதிவு செய்யப்பட்ட நோயாளிகள்", addPatient: "நோயாளியைச் சேர்",
        deletePatients: "நோயாளிகளை நீக்கு", todaysPatient: "இன்றைய நோயாளிகள்",
        doctors: "மருத்துவர்கள்", progressTracking: "முன்னேற்றக் கண்காணிப்பு",
        currentCycle: "தற்போதைய சுழற்சி", sessionCompleted: "முடிந்த அமர்வுகள்",
        analytics: "பகுப்பாய்வு", startSession: "அமர்வைத் தொடங்கு", underAge: "வயது குறைவு",
        notConsented: "ஒப்புதல் இல்லை", notQualified: "தகுதியில்லை",
        preHadsScreening: "HADS முன் பரிசோதனை", createPatient: "நோயாளியை உருவாக்கு",
        editPatient: "நோயாளியைத் திருத்து", updatePatient: "நோயாளியைப் புதுப்பி",
        personalInformation: "தனிப்பட்ட தகவல்", firstName: "முதல் பெயர்",
        lastName: "கடைசி பெயர்", dateOfBirth: "பிறந்த தேதி", month: "மாதம்",
        day: "நாள்", year: "ஆண்டு", packageType: "தொகுப்பு வகை", basic: "அடிப்படை",
        premium: "பிரீமியம்", premiumPlus: "பிரீமியம் பிளஸ்", knowYourPlan: "உங்கள் திட்டத்தை அறிக",
        caregiver: "பராமரிப்பாளர்", caregiverMobileNumber: "பராமரிப்பாளர் கைபேசி எண்",
        caregiverName: "பராமரிப்பாளர் பெயர்", caregiverEmail: "பராமரிப்பாளர் மின்னஞ்சல்",
        category: "வகை", risk: "ஆபத்து", nonRisk: "ஆபத்தில்லை",
    },

    tel: {
        back: "వెనుకకు", cancel: "రద్దు చేయి", save: "సేవ్ చేయి", edit: "సవరించు", close: "మూసివేయి",
        search: "వెతుకు", notProvided: "అందించలేదు", notSpecified: "పేర్కొనలేదు",
        na: "వర్తించదు", active: "క్రియాశీల", inactive: "నిష్క్రియ", status: "స్థితి",
        actions: "చర్యలు", name: "పేరు", gender: "లింగం", male: "పురుషుడు",
        female: "స్త్రీ", others: "ఇతరులు", email: "ఇమెయిల్", phone: "ఫోన్",
        age: "వయస్సు", notSet: "\u2014 సెట్ చేయలేదు \u2014",

        myProfile: "నా ప్రొఫైల్", resetPassword: "పాస్‌వర్డ్ రీసెట్ చేయి",
        editProfile: "ప్రొఫైల్ సవరించు", memberSince: "సభ్యులైనది",
        mobileNumber: "మొబైల్ నంబర్", preferredLanguage: "ఇష్టపడే భాష",
        fullName: "పూర్తి పేరు", emailAddress: "ఇమెయిల్ చిరునామా", phoneNumber: "ఫోన్ నంబర్",

        registeredDoctors: "నమోదైన వైద్యులు", doctor: "వైద్యుడు",
        specialization: "ప్రత్యేకత", patients: "రోగులు", addDoctor: "వైద్యుడిని జోడించు",
        deleteDoctors: "వైద్యులను తొలగించు", noDoctorsFound: "వైద్యులు కనబడలేదు",
        editDoctor: "వైద్యుడిని సవరించు", createDoctor: "వైద్యుడిని సృష్టించు",
        updateDoctor: "వైద్యుడిని నవీకరించు", doctorName: "వైద్యుని పేరు", speciality: "ప్రత్యేకత",

        todayAppointment: "నేటి అపాయింట్‌మెంట్", personalInfo: "వ్యక్తిగత సమాచారం",
        assignedDoctor: "కేటాయించిన వైద్యుడు",

        subscriberDetails: "చందాదారు వివరాలు", treatmentHistory: "చికిత్స చరిత్ర",
        preSessionDetails: "సెషన్ ముందు వివరాలు", postSessionDetails: "సెషన్ తర్వాత వివరాలు",
        commonSymptoms: "సాధారణ లక్షణాలు", assessmentScore: "మూల్యాంకన స్కోర్",
        postVital: "సెషన్ తర్వాత వైటల్స్", feedback: "అభిప్రాయం", medicalInformation: "వైద్య సమాచారం",
        primaryDiagnosis: "ప్రాథమిక నిర్ధారణ", dateOfDiagnosis: "నిర్ధారణ తేదీ",
        treatmentStartDate: "చికిత్స ప్రారంభ తేదీ", hospital: "ఆసుపత్రి",
        hospitalClinic: "ఆసుపత్రి / క్లినిక్", diagnosis: "నిర్ధారణ", createdAt: "సృష్టించబడింది",
        latestHadsScore: "తాజా HADS స్కోర్",
        assessmentsAdministered: "నిర్వహించిన మూల్యాంకనాల సంఖ్య",
        treatmentCycle: "చికిత్స చక్రం", complete: "పూర్తయింది", incomplete: "అసంపూర్ణం",
        notCompletedForSession: "ఈ సెషన్‌కు పూర్తి కాలేదు",
        noAssessmentsAssigned: "ఈ సెషన్‌కు మూల్యాంకనాలు కేటాయించబడలేదు",
        noFeedback: "ఈ సెషన్‌కు అభిప్రాయం ఇవ్వలేదు",
        postVitalUnavailable: "సెషన్ తర్వాత వైటల్ డేటా అందుబాటులో లేదు",

        bloodPressure: "రక్తపోటు", heartRate: "హృదయ స్పందన", painScale: "నొప్పి స్కేల్",
        moodRating: "మూడ్ రేటింగ్", sleepQuality: "నిద్ర నాణ్యత", nausea: "వికారం",
        fatigue: "అలసట", anxiety: "ఆందోళన", depression: "కుంగుబాటు",
        appetiteLoss: "ఆకలి తగ్గుదల", assessmentType: "మూల్యాంకన రకం",

        treatmentSession: "చికిత్స సెషన్", sessionDetails: "సెషన్ వివరాలు",
        systolic: "సిస్టోలిక్", diastolic: "డయాస్టోలిక్", noPain: "నొప్పి లేదు", worstPain: "తీవ్రమైన నొప్పి",

        registeredPatients: "నమోదైన రోగులు", addPatient: "రోగిని జోడించు",
        deletePatients: "రోగులను తొలగించు", todaysPatient: "నేటి రోగులు",
        doctors: "వైద్యులు", progressTracking: "పురోగతి ట్రాకింగ్",
        currentCycle: "ప్రస్తుత చక్రం", sessionCompleted: "పూర్తయిన సెషన్లు",
        analytics: "విశ్లేషణలు", startSession: "సెషన్ ప్రారంభించు", underAge: "వయస్సు తక్కువ",
        notConsented: "సమ్మతి లేదు", notQualified: "అర్హత లేదు",
        preHadsScreening: "HADS ముందస్తు పరీక్ష", createPatient: "రోగిని సృష్టించు",
        editPatient: "రోగిని సవరించు", updatePatient: "రోగిని నవీకరించు",
        personalInformation: "వ్యక్తిగత సమాచారం", firstName: "మొదటి పేరు",
        lastName: "చివరి పేరు", dateOfBirth: "పుట్టిన తేదీ", month: "నెల",
        day: "రోజు", year: "సంవత్సరం", packageType: "ప్యాకేజీ రకం", basic: "బేసిక్",
        premium: "ప్రీమియం", premiumPlus: "ప్రీమియం ప్లస్", knowYourPlan: "మీ ప్లాన్ తెలుసుకోండి",
        caregiver: "సంరక్షకుడు", caregiverMobileNumber: "సంరక్షకుని మొబైల్ నంబర్",
        caregiverName: "సంరక్షకుని పేరు", caregiverEmail: "సంరక్షకుని ఇమెయిల్",
        category: "వర్గం", risk: "ప్రమాదం", nonRisk: "ప్రమాదం కాదు",
    },

    kan: {
        back: "ಹಿಂದೆ", cancel: "ರದ್ದುಮಾಡು", save: "ಉಳಿಸು", edit: "ಸಂಪಾದಿಸು", close: "ಮುಚ್ಚು",
        search: "ಹುಡುಕು", notProvided: "ಒದಗಿಸಿಲ್ಲ", notSpecified: "ನಿರ್ದಿಷ್ಟಪಡಿಸಿಲ್ಲ",
        na: "ಅನ್ವಯಿಸುವುದಿಲ್ಲ", active: "ಸಕ್ರಿಯ", inactive: "ನಿಷ್ಕ್ರಿಯ", status: "ಸ್ಥಿತಿ",
        actions: "ಕ್ರಿಯೆಗಳು", name: "ಹೆಸರು", gender: "ಲಿಂಗ", male: "ಪುರುಷ",
        female: "ಮಹಿಳೆ", others: "ಇತರರು", email: "ಇಮೇಲ್", phone: "ದೂರವಾಣಿ",
        age: "ವಯಸ್ಸು", notSet: "\u2014 ಹೊಂದಿಸಿಲ್ಲ \u2014",

        myProfile: "ನನ್ನ ಪ್ರೊಫೈಲ್", resetPassword: "ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ",
        editProfile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ", memberSince: "ಸದಸ್ಯರಾದದ್ದು",
        mobileNumber: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ", preferredLanguage: "ಆದ್ಯತೆಯ ಭಾಷೆ",
        fullName: "ಪೂರ್ಣ ಹೆಸರು", emailAddress: "ಇಮೇಲ್ ವಿಳಾಸ", phoneNumber: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",

        registeredDoctors: "ನೋಂದಾಯಿತ ವೈದ್ಯರು", doctor: "ವೈದ್ಯರು",
        specialization: "ಪರಿಣತಿ", patients: "ರೋಗಿಗಳು", addDoctor: "ವೈದ್ಯರನ್ನು ಸೇರಿಸಿ",
        deleteDoctors: "ವೈದ್ಯರನ್ನು ಅಳಿಸಿ", noDoctorsFound: "ವೈದ್ಯರು ಕಂಡುಬಂದಿಲ್ಲ",
        editDoctor: "ವೈದ್ಯರನ್ನು ಸಂಪಾದಿಸಿ", createDoctor: "ವೈದ್ಯರನ್ನು ರಚಿಸಿ",
        updateDoctor: "ವೈದ್ಯರನ್ನು ನವೀಕರಿಸಿ", doctorName: "ವೈದ್ಯರ ಹೆಸರು", speciality: "ಪರಿಣತಿ",

        todayAppointment: "ಇಂದಿನ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್", personalInfo: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ",
        assignedDoctor: "ನಿಯೋಜಿತ ವೈದ್ಯರು",

        subscriberDetails: "ಚಂದಾದಾರರ ವಿವರಗಳು", treatmentHistory: "ಚಿಕಿತ್ಸೆ ಇತಿಹಾಸ",
        preSessionDetails: "ಅವಧಿಗೂ ಮುನ್ನದ ವಿವರಗಳು", postSessionDetails: "ಅವಧಿಯ ನಂತರದ ವಿವರಗಳು",
        commonSymptoms: "ಸಾಮಾನ್ಯ ಲಕ್ಷಣಗಳು", assessmentScore: "ಮೌಲ್ಯಮಾಪನ ಸ್ಕೋರ್",
        postVital: "ಅವಧಿಯ ನಂತರದ ವೈಟಲ್", feedback: "ಪ್ರತಿಕ್ರಿಯೆ", medicalInformation: "ವೈದ್ಯಕೀಯ ಮಾಹಿತಿ",
        primaryDiagnosis: "ಪ್ರಾಥಮಿಕ ರೋಗನಿರ್ಣಯ", dateOfDiagnosis: "ರೋಗನಿರ್ಣಯದ ದಿನಾಂಕ",
        treatmentStartDate: "ಚಿಕಿತ್ಸೆ ಪ್ರಾರಂಭ ದಿನಾಂಕ", hospital: "ಆಸ್ಪತ್ರೆ",
        hospitalClinic: "ಆಸ್ಪತ್ರೆ / ಕ್ಲಿನಿಕ್", diagnosis: "ರೋಗನಿರ್ಣಯ", createdAt: "ರಚಿಸಲಾಗಿದೆ",
        latestHadsScore: "ಇತ್ತೀಚಿನ HADS ಸ್ಕೋರ್",
        assessmentsAdministered: "ನಡೆಸಲಾದ ಮೌಲ್ಯಮಾಪನಗಳ ಸಂಖ್ಯೆ",
        treatmentCycle: "ಚಿಕಿತ್ಸೆ ಚಕ್ರ", complete: "ಪೂರ್ಣಗೊಂಡಿದೆ", incomplete: "ಅಪೂರ್ಣ",
        notCompletedForSession: "ಈ ಅವಧಿಗೆ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ",
        noAssessmentsAssigned: "ಈ ಅವಧಿಗೆ ಯಾವುದೇ ಮೌಲ್ಯಮಾಪನ ನಿಯೋಜಿಸಿಲ್ಲ",
        noFeedback: "ಈ ಅವಧಿಗೆ ಪ್ರತಿಕ್ರಿಯೆ ಸಲ್ಲಿಸಿಲ್ಲ",
        postVitalUnavailable: "ಅವಧಿಯ ನಂತರದ ವೈಟಲ್ ಡೇಟಾ ಲಭ್ಯವಿಲ್ಲ",

        bloodPressure: "ರಕ್ತದೊತ್ತಡ", heartRate: "ಹೃದಯ ಬಡಿತ", painScale: "ನೋವು ಪ್ರಮಾಣ",
        moodRating: "ಮನಃಸ್ಥಿತಿ ರೇಟಿಂಗ್", sleepQuality: "ನಿದ್ರೆ ಗುಣಮಟ್ಟ", nausea: "ವಾಕರಿಕೆ",
        fatigue: "ಆಯಾಸ", anxiety: "ಆತಂಕ", depression: "ಖಿನ್ನತೆ",
        appetiteLoss: "ಹಸಿವು ಕಡಿಮೆ", assessmentType: "ಮೌಲ್ಯಮಾಪನ ಪ್ರಕಾರ",

        treatmentSession: "ಚಿಕಿತ್ಸೆ ಅವಧಿ", sessionDetails: "ಅವಧಿ ವಿವರಗಳು",
        systolic: "ಸಿಸ್ಟೊಲಿಕ್", diastolic: "ಡಯಾಸ್ಟೊಲಿಕ್", noPain: "ನೋವು ಇಲ್ಲ", worstPain: "ತೀವ್ರ ನೋವು",

        registeredPatients: "ನೋಂದಾಯಿತ ರೋಗಿಗಳು", addPatient: "ರೋಗಿಯನ್ನು ಸೇರಿಸಿ",
        deletePatients: "ರೋಗಿಗಳನ್ನು ಅಳಿಸಿ", todaysPatient: "ಇಂದಿನ ರೋಗಿಗಳು",
        doctors: "ವೈದ್ಯರು", progressTracking: "ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್",
        currentCycle: "ಪ್ರಸ್ತುತ ಚಕ್ರ", sessionCompleted: "ಪೂರ್ಣಗೊಂಡ ಅವಧಿಗಳು",
        analytics: "ವಿಶ್ಲೇಷಣೆ", startSession: "ಅವಧಿ ಪ್ರಾರಂಭಿಸಿ", underAge: "ವಯಸ್ಸು ಕಡಿಮೆ",
        notConsented: "ಸಮ್ಮತಿ ಇಲ್ಲ", notQualified: "ಅರ್ಹತೆ ಇಲ್ಲ",
        preHadsScreening: "HADS ಪೂರ್ವ ತಪಾಸಣೆ", createPatient: "ರೋಗಿಯನ್ನು ರಚಿಸಿ",
        editPatient: "ರೋಗಿಯನ್ನು ಸಂಪಾದಿಸಿ", updatePatient: "ರೋಗಿಯನ್ನು ನವೀಕರಿಸಿ",
        personalInformation: "ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ", firstName: "ಮೊದಲ ಹೆಸರು",
        lastName: "ಕೊನೆಯ ಹೆಸರು", dateOfBirth: "ಹುಟ್ಟಿದ ದಿನಾಂಕ", month: "ತಿಂಗಳು",
        day: "ದಿನ", year: "ವರ್ಷ", packageType: "ಪ್ಯಾಕೇಜ್ ಪ್ರಕಾರ", basic: "ಮೂಲ",
        premium: "ಪ್ರೀಮಿಯಂ", premiumPlus: "ಪ್ರೀಮಿಯಂ ಪ್ಲಸ್", knowYourPlan: "ನಿಮ್ಮ ಯೋಜನೆ ತಿಳಿಯಿರಿ",
        caregiver: "ಆರೈಕೆದಾರ", caregiverMobileNumber: "ಆರೈಕೆದಾರರ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
        caregiverName: "ಆರೈಕೆದಾರರ ಹೆಸರು", caregiverEmail: "ಆರೈಕೆದಾರರ ಇಮೇಲ್",
        category: "ವರ್ಗ", risk: "ಅಪಾಯ", nonRisk: "ಅಪಾಯವಿಲ್ಲ",
    },
};

export default translations;
